export enum TradeContractType {
    trade,
    auctionHouse,
}